import { createContext, useContext } from 'react';
import LocalTransform from './LocalTransform';
export const TransformContext = createContext(new LocalTransform({
  width: 800,
  height: 600
}));
export default function useLocalTransform() {
  return useContext(TransformContext);
}